// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LlIcon from "../components/LlIcon.bs.js";
import * as Region from "common/src/Region.bs.js";

function LbPlayerName(Props) {
  var region = Props.region;
  var playerName = Props.playerName;
  var companionId = Props.companionId;
  var regionName = Region.toName3(region);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex-shrink-0 text-white2 leading-none w-[38px] text-center pr-1 " + (
                    regionName === "EUNE" ? "text-[11px]" : "text-xs"
                  )
                }, regionName), React.createElement(LlIcon.make, {
                  companionId: companionId,
                  size: 28,
                  className: "inline mr-2 my-[-1px]"
                }), React.createElement("div", {
                  className: "truncate"
                }, playerName));
}

var make = React.memo(LbPlayerName);

export {
  make ,
  
}
/* make Not a pure module */
